(function() {
    angular.module('emarket.main.post').controller('PostSuccessController', ['$stateParams', '$mdMedia', 'Announcer', function ($stateParams, $mdMedia, Announcer) {
        var vm = this;
        vm.id = $stateParams.id;
        var announcer = Announcer.createEmitter();
        if($mdMedia('xs') || $mdMedia('sm')) {
            announcer.emit(Announcer.types.FULL_SCREEN_MODE_NO_TOOLBAR);
        }

    }]);
}());
